<template>
  <div class="side-tools">
    <el-button class="btn solutions" @click="obtainSolutionsClick()">
      <div>获取解决方案</div>
    </el-button>
    <el-popover
      placement="left"
      trigger="click"
      popper-class="contact-popover"
      v-if="!checkDevice()"
    >
      <template #default>
        <div class="contact">
          <div class="email-box">
            <div class="email">
              <img
                src="@/assets/images/sidetools_email_icon.png"
                alt=""
                class="email-icon"
              />
              <div class="email-content">
                <span class="email-title">邮箱咨询</span>
              </div>
            </div>
            <div class="email-text" href="mailto:sales@tipine.cn">
              sales@tipine.cn
            </div>
          </div>

          <div class="qrcode">
            <img src="@/assets/images/code1.png" alt="" class="qrcode-img" />
            <span class="qrcode-text">扫码获取专属客服</span>
          </div>
        </div>
      </template>
      <template #reference>
        <el-button class="btn contact">
          <img class="icon" src="@/assets/images/sidetools_contact_icon.png" />
          <div class="text">联系我们</div>
        </el-button>
      </template>
    </el-popover>
    <el-button class="btn contact" v-else @click="contactClick">
      <img class="icon" src="@/assets/images/sidetools_contact_icon.png" />
      <div class="text">联系我们</div>
    </el-button>
    <el-button class="btn returntop" @click="returnTop">
      <svg-icon
        class="btn-icon"
        name="icon-top-arrow"
        :width="22"
        :height="22"
        color="#000"
      />
    </el-button>
  </div>
</template>

<script lang="ts" setup name="SideTools">
import { ref, nextTick, reactive } from "vue";
import EventBus from "@/utils/eventBus";
import { checkDevice } from "@/utils/index.ts";

const returnTop = () => {
  window.scrollTo(0, 0);
};
// 获取解决方案
const obtainSolutionsClick = () => {
  EventBus.$emit("modelSolutionOpen");
};

// 联系我们
const contactClick = () => {
  console.log("联系我们");
  EventBus.$emit("modelConnectionOpen");
};
</script>

<style scoped lang="scss">
.side-tools {
  position: fixed;
  right: 10px;
  top: 50%;
  transform: translateY(-70%);
  z-index: 9999;
  .btn {
    display: block;
    width: 50px;
    box-sizing: border-box;
    padding: 0;
    height: auto;
    border-radius: 50px;
    text-align: center;
    margin: auto;
    outline: none;
    & + .btn {
      margin-top: 10px;
    }
    :deep(span) {
      word-wrap: break-word;
      display: block;
      white-space: pre-wrap;
    }
    &.solutions {
      padding: 20px 15px;
      background-color: #1767f0;
      color: #fff;
      font-size: 15px;
      line-height: 1.2;
    }
    &.contact {
      background-color: #fff;
      color: #1767f0;
      padding: 20px 15px;
      text-align: center;
      .icon {
        display: block;
        margin-bottom: 10px;
        width: 100%;
        max-width: 100%;
      }
      .text {
        font-size: 15px;
        line-height: 1.2;
      }
    }
    &.returntop {
      height: 50px;
      background: #fff;
      .btn-icon {
        display: block;
        margin: auto;
        width: 40%;
        height: 40%;
      }
    }
  }
}

@media screen and (max-width: 1024px) {
  .side-tools {
    position: fixed;
    right: -1px;
    left: -1px;
    bottom: 0;
    top: inherit;
    transform: translateY(0);
    display: flex;
    align-items: center;
    .btn {
      width: auto;
      flex: 1;
			width: 50%;
      border-radius: 0;
      border: 0;
      text-align: center;
      height: 96px;
			border-color: #fff;
      & > :deep(span) {
        display: flex;
        justify-content: center;
        align-items: center;
      }
      &.solutions {
        font-size: 32px;
        line-height: 1;
        margin: 0;
      }
      &.contact {
        font-size: 30px;
        line-height: 1;
        margin: 0;
				background-color: #d9e8ff;
				
        .icon {
          width: 40px;
          margin: 0 20px 0 0;
        }
        .text {
          line-height: 1;
          font-size: 32px;
        }
      }
      &.returntop {
        position: absolute;
        width: 96px;
        right: 20px;
        top: -160px;
        height: 96px;
        background: #fff;
        border-radius: 96px;
      }
    }
  }
}

.contact {
  display: flex;
  flex-direction: column;
  .email-box {
    position: relative;
    &::after {
      content: "";
      display: block;
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 1px;
      background-color: #e3e3e3;
    }
    .email-text {
      font-weight: 400;
      font-size: 20px;
      color: #1767f0;
      line-height: 1;
      padding: 15px 0;
      box-sizing: border-box;
      cursor: pointer;
    }
  }
  .email {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    position: relative;

    .email-icon {
      width: 22px;
      height: 18px;
      flex-shrink: 0;
    }
    .email-content {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      margin-left: 17px;
      font-family: Source Han Sans CN;

      .email-title {
        font-weight: 400;
        font-size: 16px;
        color: #000000;
        margin-top: 0;
        line-height: 1;
      }
    }
  }
  .qrcode {
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-top: 23px;
    .qrcode-img {
      width: 141px;
      height: 141px;
      margin: 0 auto;
    }
    .qrcode-text {
      font-family: Source Han Sans CN;
      font-weight: 400;
      font-size: 18px;
      color: #000000;
      margin-top: 16px;
      text-align: center;
    }
  }
}
</style>
